export function initializePrototype() {
const routeTitles = {
      home: "羚喵加速器｜Android 手游加速",
      library: "游戏库｜羚喵加速器",
      detail: "游戏支持详情｜羚喵加速器",
      download: "下载中心｜羚喵加速器",
      news: "手游资讯｜羚喵加速器",
      article: "使用指南｜羚喵加速器",
      help: "帮助中心｜羚喵加速器",
      about: "关于我们｜羚喵加速器"
    };

    const validRoutes = new Set(Object.keys(routeTitles));
    const legacyRoute = new URLSearchParams(location.search).get("page");
    const state = {
      category: "推荐",
      region: "全部",
      helpCategory: "全部",
      toastTimer: null
    };

    const gameAssets = {
      "航海王：壮志雄心": {
        icon: "/assets/games/op-ambition-icon.png",
        cover: "/assets/games/onepiece-cover.jpg",
        category: "动作格斗"
      },
      "火影忍者": {
        icon: "/assets/games/naruto-icon.png",
        cover: "/assets/games/naruto-cover.png",
        category: "动作格斗"
      },
      "火影忍者手游": {
        icon: "/assets/games/naruto-icon.png",
        cover: "/assets/games/naruto-cover.png",
        category: "动作格斗"
      },
      "境·界 刀鸣": {
        icon: "/assets/games/bleach-icon.png",
        cover: "/assets/games/bleach-cover.jpg",
        category: "角色扮演"
      },
      "诛仙世界": {
        icon: "/assets/games/xianjie-icon.png",
        cover: "/assets/games/zhenxieren-focus.jpg",
        category: "角色扮演"
      },
      "航海王：热血航线": {
        icon: "/assets/games/onepiece-icon.png",
        cover: "/assets/games/onepiece-cover.jpg",
        category: "动作冒险"
      },
      "龙族：卡塞尔之门": {
        icon: "/assets/games/dragonraja-icon.png",
        cover: "/assets/games/dragonraja-cover.jpg",
        category: "策略"
      },
      "遗忘之海": {
        icon: "/assets/games/forgotten-sea-icon.png",
        cover: "/assets/games/onepiece-cover.jpg",
        category: "角色扮演"
      },
      "烈焰行动": {
        icon: "/assets/games/lieyan-icon.gif",
        cover: "/assets/games/bleach-cover.jpg",
        category: "射击"
      }
    };

    const articlePresets = [
      {
        match: "环境检查",
        category: "使用指南",
        intro: "游戏启动前的异常往往来自空间不足、后台冲突、版本不完整或系统权限。先确认设备环境，再判断是否需要调整加速线路。",
        sectionTitle: "先排除四类设备冲突",
        sectionBody: "依次检查可用空间、后台下载或更新任务、游戏版本完整性以及 VPN 与网络权限。设备问题未排除前，线路测试结果不具备代表性。"
      },
      {
        match: "中断",
        category: "下载管理",
        intro: "下载任务中断可能来自源站连接、存储空间、网络切换或安装包校验。重新开始下载不是唯一处理方式。",
        sectionTitle: "先定位任务中断阶段",
        sectionBody: "检查任务是在建立连接、持续下载、校验还是安装阶段失败，并保留错误码与剩余空间信息，再决定续传、换源或重新下载。"
      },
      {
        match: "国际服",
        category: "产品说明",
        intro: "同一款手游的国服、日服、韩服和国际服会连接不同服务、登录体系与资源域名，因此不能用一条通用规则处理。",
        sectionTitle: "区服支持必须分别核验",
        sectionBody: "羚喵加速器根据设备内已安装版本识别区服，只展示已经开放的目标服务与线路。未安装外服版本时，不会凭空显示外服选项。"
      },
      {
        match: "预约",
        category: "新游观察",
        intro: "预约用于记录用户关注和上线提醒，不代表已经获得游戏下载授权，也不代表对应区服已经完成加速适配。",
        sectionTitle: "预约、下载与加速是三个状态",
        sectionBody: "预约成功后保存提醒偏好；游戏正式上线并完成渠道授权后才开放下载；线路核验完成后，客户端才显示可用区服。"
      }
    ];
const siteNav = document.getElementById("site-nav");
    const modal = document.getElementById("site-modal");
    const modalContent = document.getElementById("modal-content");
    const toast = document.getElementById("site-toast");

    function currentRoute() {
      const hashRoute = location.hash.replace(/^#/, "").split("?")[0];
      const candidate = hashRoute || legacyRoute || "home";
      return validRoutes.has(candidate) ? candidate : "home";
    }

    function navRoute(route) {
      return route === "detail" ? "library" : route === "article" ? "news" : route;
    }

    function renderRoute(options = {}) {
      const route = currentRoute();
      document.querySelectorAll(".view").forEach((view) => {
        view.classList.toggle("active", view.dataset.view === route);
      });
      document.querySelectorAll("[data-nav]").forEach((link) => {
        link.classList.toggle("current", link.dataset.nav === navRoute(route));
      });
      document.title = routeTitles[route];
      siteNav.classList.remove("menu-open");
      const menuButton = siteNav.querySelector("[data-action='toggle-menu']");
      menuButton.setAttribute("aria-expanded", "false");
      menuButton.textContent = "☰";
      if (!options.preserveScroll) window.scrollTo({ top: 0, behavior: "auto" });
    }

    function navigate(route) {
      if (!validRoutes.has(route)) return;
      if (currentRoute() === route) {
        renderRoute();
      } else {
        location.hash = route;
      }
    }

    function showToast(message) {
      toast.textContent = message;
      toast.classList.add("show");
      window.clearTimeout(state.toastTimer);
      state.toastTimer = window.setTimeout(() => toast.classList.remove("show"), 2800);
    }

    function openModal(type) {
      if (type === "download") {
        modalContent.innerHTML = `
          <div class="modal-brand"><img src="/assets/lingmiao-accelerator-logo.png" alt=""><div><strong>羚喵加速器</strong><p style="margin:4px 0 0">Android 手游加速</p></div></div>
          <h2 id="modal-title">Android 安装包尚未正式发布</h2>
          <p>当前页面为可交互官网原型，未接入真实 APK 下载。正式发布后，这里将展示版本号、文件大小、签名摘要和下载地址。</p>
          <div class="modal-meta"><span>支持 Android 8.0+</span><span>加速线路需登录使用</span><span>当前规划版本 V1.0.0</span><span>正式包需完成备案与签名核验</span></div>
          <div class="modal-actions"><button class="outline-btn" type="button" data-action="close-modal">暂不下载</button><button class="primary-btn" type="button" data-modal-notify>登记上线提醒</button></div>`;
      } else if (type === "support") {
        modalContent.innerHTML = `
          <h2 id="modal-title" style="margin-top:0">提交支持申请</h2>
          <p>请填写游戏、区服和设备环境。此原型不会向服务器发送数据，提交后仅演示交互结果。</p>
          <div class="modal-form">
            <label>游戏名称<input id="support-game" placeholder="例如：航海王：壮志雄心"></label>
            <label>区服与设备<input id="support-environment" placeholder="例如：国服 / Android 云手机"></label>
            <label>问题描述<textarea id="support-description" rows="4" placeholder="描述当前状态、错误提示或期望支持的能力"></textarea></label>
          </div>
          <div class="modal-actions"><button class="outline-btn" type="button" data-action="close-modal">取消</button><button class="primary-btn" type="button" data-modal-submit>提交申请</button></div>`;
      } else {
        const isPrivacy = type === "privacy";
        modalContent.innerHTML = `
          <h2 id="modal-title" style="margin-top:0">${isPrivacy ? "隐私政策" : "用户协议"}</h2>
          <p>${isPrivacy ? "正式隐私政策将说明个人信息处理、设备权限、VPNService 用途、第三方 SDK、存储期限与用户权利。" : "正式用户协议将说明账号规则、服务范围、收费项目、知识产权、违约处理和争议解决。"}</p>
          <div class="modal-meta"><span>运营主体：湖南小算科技信息有限公司</span><span>产品名称：羚喵加速器</span><span>当前状态：法务文本待核验</span><span>上线要求：App 与官网版本一致</span></div>
          <p>此处只展示结构和主体信息，不冒充已经完成法务审核的正式协议。</p>
          <div class="modal-actions"><button class="primary-btn" type="button" data-action="close-modal">我知道了</button></div>`;
      }
      modal.classList.add("open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      modal.querySelector(".modal-close").focus();
    }

    function closeModal() {
      modal.classList.remove("open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    function updateGameDetail(card) {
      const title = card.querySelector("h3")?.textContent.trim() || "航海王：壮志雄心";
      const asset = gameAssets[title] || gameAssets["航海王：壮志雄心"];
      const region = card.dataset.regionValue || "国服";
      const category = (card.dataset.categoryValue || asset.category).replace("推荐", "").trim() || asset.category;
      const statusText = card.querySelector(".gamehub-item-status strong")?.textContent.trim() || "已支持";
      const isReady = statusText.includes("支持") && !statusText.includes("即将");
      document.getElementById("detail-title").textContent = title;
      document.getElementById("detail-breadcrumb").textContent = title;
      document.getElementById("detail-icon").src = asset.icon;
      document.getElementById("detail-bg").style.backgroundImage = `url("${asset.cover}")`;
      document.getElementById("detail-region").textContent = region;
      document.getElementById("detail-category").textContent = category;
      const status = document.getElementById("detail-support-status");
      status.textContent = statusText;
      status.classList.toggle("status-ready", isReady);
    }

    function applyGameFilters() {
      const query = document.getElementById("game-search").value.trim().toLowerCase();
      const cards = [...document.querySelectorAll("[data-view='library'] [data-game-card]")];
      cards.forEach((card) => {
        const categoryMatch = state.category === "全部" || (card.dataset.categoryValue || "").includes(state.category);
        const regionMatch = state.region === "全部" || card.dataset.regionValue === state.region;
        const queryMatch = !query || card.textContent.toLowerCase().includes(query);
        card.classList.toggle("is-hidden", !(categoryMatch && regionMatch && queryMatch));
      });
      const directoryVisible = [...document.querySelectorAll(".gamehub-list [data-game-card]")].some((card) => !card.classList.contains("is-hidden"));
      document.getElementById("game-empty").classList.toggle("show", !directoryVisible);
    }

    function setCategory(value) {
      state.category = value;
      document.querySelectorAll("[data-category]").forEach((item) => item.classList.toggle("on", item.dataset.category === value));
      applyGameFilters();
    }

    function setRegion(value) {
      state.region = value;
      document.querySelectorAll("[data-region]").forEach((item) => item.classList.toggle("on", item.dataset.region === value));
      applyGameFilters();
    }

    function applyNewsSearch() {
      const query = document.getElementById("news-search").value.trim().toLowerCase();
      const items = [...document.querySelectorAll("[data-news-item]")];
      items.forEach((item) => item.classList.toggle("is-hidden", Boolean(query) && !item.textContent.toLowerCase().includes(query)));
      document.getElementById("news-empty").classList.toggle("show", !items.some((item) => !item.classList.contains("is-hidden")));
    }

    function applyHelpFilters() {
      const query = document.getElementById("help-search").value.trim().toLowerCase();
      const items = [...document.querySelectorAll("[data-faq]")];
      items.forEach((item) => {
        const categoryMatch = state.helpCategory === "全部" || item.dataset.helpValue === state.helpCategory;
        const queryMatch = !query || item.textContent.toLowerCase().includes(query);
        item.classList.toggle("is-hidden", !(categoryMatch && queryMatch));
      });
      document.getElementById("help-empty").classList.toggle("show", !items.some((item) => !item.classList.contains("is-hidden")));
    }

    function updateArticle(card) {
      const title = card.querySelector("h2, h3")?.textContent.trim() || "手游更新下载慢，先判断下载源、网络链路与后台占用";
      const category = card.querySelector("small")?.textContent.trim() || card.querySelector(".news-date")?.textContent.split("·").pop().trim() || "使用指南";
      const preset = articlePresets.find((item) => title.includes(item.match));
      const image = card.querySelector("img")?.src;
      document.getElementById("article-title").textContent = title;
      document.getElementById("article-category").textContent = preset?.category || category;
      if (image) document.getElementById("article-cover").src = image;
      document.getElementById("article-intro").textContent = preset?.intro || "本文从设备、网络与游戏版本三个维度说明问题定位方法，避免只根据单一现象得出结论。";
      document.getElementById("article-section-title").textContent = preset?.sectionTitle || "先确认问题发生在哪个阶段";
      document.getElementById("article-section-body").textContent = preset?.sectionBody || "记录设备环境、游戏版本、区服和错误信息，再根据实际状态选择处理路径。";
    }

    document.addEventListener("click", (event) => {
      const closeButton = event.target.closest("[data-action='close-modal']");
      if (closeButton) {
        closeModal();
        return;
      }

      const menuButton = event.target.closest("[data-action='toggle-menu']");
      if (menuButton) {
        const open = siteNav.classList.toggle("menu-open");
        menuButton.setAttribute("aria-expanded", String(open));
        menuButton.textContent = open ? "×" : "☰";
        return;
      }

      const routeElement = event.target.closest("[data-route]");
      if (routeElement) {
        event.preventDefault();
        navigate(routeElement.dataset.route);
        return;
      }

      if (event.target.closest("[data-download]")) {
        openModal("download");
        return;
      }

      const featured = event.target.closest("[data-game-featured]");
      if (featured) {
        event.preventDefault();
        updateGameDetail(document.querySelector("[data-view='library'] .showcase-game"));
        navigate("detail");
        return;
      }

      const gameCard = event.target.closest("[data-game-card]");
      if (gameCard) {
        updateGameDetail(gameCard);
        navigate("detail");
        return;
      }

      const articleCard = event.target.closest("[data-article]");
      if (articleCard) {
        updateArticle(articleCard);
        navigate("article");
        return;
      }

      const category = event.target.closest("[data-category]");
      if (category) {
        setCategory(category.dataset.category);
        return;
      }

      if (event.target.closest("[data-category-reset]")) {
        event.preventDefault();
        setCategory("全部");
        document.querySelector(".gamehub-directory-head").scrollIntoView({ behavior: "smooth" });
        return;
      }

      const region = event.target.closest("[data-region]");
      if (region) {
        setRegion(region.dataset.region);
        return;
      }

      const faqButton = event.target.closest(".faq-question");
      if (faqButton) {
        const item = faqButton.closest(".faq-item");
        const open = item.classList.toggle("open");
        faqButton.querySelector("span:last-child").textContent = open ? "−" : "＋";
        return;
      }

      const helpCategory = event.target.closest("[data-help-category]");
      if (helpCategory) {
        state.helpCategory = helpCategory.dataset.helpCategory;
        document.querySelectorAll("[data-help-category]").forEach((item) => item.classList.toggle("on", item === helpCategory));
        applyHelpFilters();
        return;
      }

      const legal = event.target.closest("[data-legal]");
      if (legal) {
        event.preventDefault();
        openModal(legal.dataset.legal);
        return;
      }

      if (event.target.closest("[data-support-request]")) {
        event.preventDefault();
        openModal("support");
        return;
      }

      if (event.target.closest("[data-modal-notify]")) {
        closeModal();
        showToast("已登记原型中的上线提醒，正式版本将接入账号通知。");
        return;
      }

      if (event.target.closest("[data-modal-submit]")) {
        const game = document.getElementById("support-game").value.trim();
        const description = document.getElementById("support-description").value.trim();
        if (!game || !description) {
          showToast("请至少填写游戏名称和问题描述。");
          return;
        }
        closeModal();
        showToast("申请已在原型中提交，正式版本将接入工单系统。");
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("open")) closeModal();
      if ((event.key === "Enter" || event.key === " ") && event.target.matches("[role='button']")) {
        event.preventDefault();
        event.target.click();
      }
    });

    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeModal();
    });

    document.getElementById("game-search").addEventListener("input", applyGameFilters);
    document.querySelector("[data-action='search-games']").addEventListener("click", () => {
      applyGameFilters();
      document.querySelector(".gamehub-directory-head").scrollIntoView({ behavior: "smooth" });
    });
    document.getElementById("news-search").addEventListener("input", applyNewsSearch);
    document.getElementById("help-search").addEventListener("input", applyHelpFilters);
    window.addEventListener("hashchange", () => renderRoute());

    if (!location.hash) {
      history.replaceState(null, "", `#${validRoutes.has(legacyRoute) ? legacyRoute : "home"}`);
    }
    renderRoute();
    applyGameFilters();
}
